import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import Slider from 'react-slick'

import sinfoto from '../../../../src/img/sinfoto.jpg'
import { sanitizeImageUrl, sanitizeYoutubeUrl } from '../../../helpers/sanitizeUrl.js'
import { toEmbedUrl } from '../../../helpers/toEmbedUrl.js'
import { useImagenesPublicacion } from '../../../hooks/useImagenesPublicacion.js'
import CarouselBig from '../carouselBig/CarouselBig'
import styles from './Carousel.module.css'
import './slick/slick.css'
import './slick/slick-theme.css'

const Carousel = ({ detalle }) => {
  const refSlider = useRef()
  const [show, setShow] = useState(false)
  const { adjuntos, loadingImagenes, fetchImagenes } = useImagenesPublicacion()

  useEffect(() => {
    if (detalle?.idPublicacion) {
      fetchImagenes({
        idPublicaciones: [detalle.idPublicacion],
        soloImagenPrincipal: false
      })
    }
  }, [detalle?.idPublicacion])

  const settings = {
    dots: true,
    infinite: adjuntos.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px'
  }

  return (
    <>
      {loadingImagenes ? (
        <div className="mx-auto spinner-border text-secondary">
          <span className="sr-only"></span>
        </div>
      ) : (
        <Slider {...settings} ref={refSlider}>
          {adjuntos.map((adjunto) => (
            <div key={adjunto.idAdjunto} className="slide-container">
              <img
                src={sanitizeImageUrl(adjunto.url, sinfoto)}
                alt={adjunto.nombre}
                className={styles.zoomInButton}
                onClick={() => setShow(true)}
              />
            </div>
          ))}
          {detalle?.youtube && sanitizeYoutubeUrl(toEmbedUrl(detalle?.youtube)) && (
            <div className="slide-container">
              <iframe
                className={styles.youtubeContainer}
                src={sanitizeYoutubeUrl(toEmbedUrl(detalle?.youtube))}
                title="Link a YouTube"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </Slider>
      )}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="modalCarousel"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CarouselBig idPublicacion={detalle?.idPublicacion} adjuntos={adjuntos} />
        </Modal.Body>
      </Modal>
    </>
  )
}

Carousel.propTypes = {
  detalle: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    youtube: PropTypes.string
  }).isRequired
}
export default Carousel
